/* ==========================================================================
   claude 产品首屏 overview — 背景影片与成片弹窗
   1. 背景影片：可见 ≥ 20% 才给 <video> 设 src 并播放；离开视口、切到别的标签页就暂停。
      暂停键按了就一直停着；系统开了减弱动效时不自动播放，按钮是「Play」。
   2. 成片弹窗：点「Watch the film」才把 <template> 里的 <video controls> 放进弹窗；
      关闭（×、点遮罩、Esc）时移除视频，焦点回到按钮；打开期间背景影片暂停。
   不加 scroll 监听。
   ========================================================================== */

(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function initOverview(root) {
    if (!root || root._ovInit) return;
    root._ovInit = true;

    var video = root.querySelector('[data-ov-video]');
    var btn = root.querySelector('[data-ov-pause]');
    var txt = btn ? btn.querySelector('[data-ov-pause-text]') : null;
    var dialog = root.querySelector('[data-ov-dialog]');
    var opener = root.querySelector('[data-ov-film-open]');
    var closer = dialog ? dialog.querySelector('[data-ov-film-close]') : null;
    var frame = dialog ? dialog.querySelector('[data-ov-frame]') : null;
    var tpl = dialog ? dialog.querySelector('[data-ov-film-tpl]') : null;

    var userPaused = RM.matches;
    var inView = false;
    var filmOpen = false;
    var io = null;
    var handlers = [];

    function on(el, ev, fn) {
      if (!el) return;
      el.addEventListener(ev, fn);
      handlers.push([el, ev, fn]);
    }

    /* ---------- 背景影片 ---------- */
    function label() {
      if (!btn) return;
      btn.setAttribute('data-ov-paused', userPaused ? 'true' : 'false');
      btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      if (txt) txt.textContent = userPaused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause');
    }

    function ensureSrc() {
      var src = MOBILE.matches ? video.getAttribute('data-src-m') : video.getAttribute('data-src-d');
      if (!src || video.getAttribute('src') === src) return;
      root.removeAttribute('data-ov-playing');
      video.setAttribute('src', src);
      video.load();
    }

    function update() {
      if (!video) return;
      var want = inView && !userPaused && !filmOpen && !document.hidden;
      if (want) {
        ensureSrc();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    }

    if (video) {
      on(video, 'playing', function () {
        if (!video.paused && video.readyState >= 2) root.setAttribute('data-ov-playing', '');
      });
      on(video, 'emptied', function () { root.removeAttribute('data-ov-playing'); });
      on(video, 'error', function () { root.removeAttribute('data-ov-playing'); });
      on(MOBILE, 'change', function () {
        if (video.getAttribute('src')) ensureSrc();
        update();
      });
      on(document, 'visibilitychange', update);
      on(btn, 'click', function () { userPaused = !userPaused; label(); update(); });
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          update();
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        inView = true;
        update();
      }
      label();
    }

    /* ---------- 成片弹窗 ---------- */
    function closeFilm() {
      if (!filmOpen) return;
      filmOpen = false;
      if (frame) frame.textContent = '';
      if (dialog.open) dialog.close();
      update();
      if (opener) opener.focus({ preventScroll: true });
    }

    function openFilm() {
      if (!dialog || !frame || !tpl || filmOpen) return;
      filmOpen = true;
      update();
      frame.textContent = '';
      frame.appendChild(tpl.content.cloneNode(true));
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      var film = frame.querySelector('video');
      if (film) {
        var p = film.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    on(opener, 'click', openFilm);
    on(closer, 'click', closeFilm);
    /* 点遮罩：点击目标就是 dialog 本身 */
    on(dialog, 'click', function (e) { if (e.target === dialog) closeFilm(); });
    /* Esc：浏览器先触发 cancel 再关；页面不可见时 close 事件会被推迟，所以两处都收尾（幂等） */
    on(dialog, 'cancel', function (e) { e.preventDefault(); closeFilm(); });
    on(dialog, 'close', closeFilm);

    root._ovTeardown = function () {
      if (io) io.disconnect();
      for (var i = 0; i < handlers.length; i++) handlers[i][0].removeEventListener(handlers[i][1], handlers[i][2]);
      if (video && !video.paused) video.pause();
      root.removeAttribute('data-ov-playing');
      if (frame) frame.textContent = '';
      delete root._ovInit;
      delete root._ovTeardown;
    };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ov-root]');
    for (var i = 0; i < roots.length; i++) initOverview(roots[i]);
  }

  function rootOf(t) { return t && t.querySelector ? t.querySelector('[data-ov-root]') : null; }

  document.addEventListener('shopify:section:load', function (e) { initOverview(rootOf(e.target)); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = rootOf(e.target);
    if (root && root._ovTeardown) root._ovTeardown();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
